import { createAction } from "@reduxjs/toolkit";
import { Station } from "src/types/station";


export const RYNAN_STATION_GET_ALL = createAction<{ stations: Station[] }>( "rynanStation/getAll");

export const RYNAN_STATION_SET_SELECTED = createAction<{ station: Station | null }>("rynanStation/setSelected");
